/**
 * Module: SHARED-LIBRARY
 * Description: TBD
 * Version: 3.0.2020.07281
 */

import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { ModalDialogComponent } from "./components/modal-dialog/modal-dialog.component";
import { ModalDialogService } from "./components/modal-dialog/modal-dialog.service";
import { NotificationPaneComponent } from "./components/notification-pane/notification-pane.component";
import { NotificationPaneService } from "./components/notification-pane/notification-pane.service";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { PaginationComponent } from "./form-controls/pagination/pagination.component";

@NgModule({
    declarations: [
        // COMPONENTS
        ModalDialogComponent,
        NotificationPaneComponent,
        SpinnerComponent,
        // FORM CONTROLS
        PaginationComponent
    ],
    exports: [
        // COMPONENTS
        ModalDialogComponent,
        NotificationPaneComponent,
        SpinnerComponent,
        // FORM CONTROLS
        PaginationComponent,
        // MODULES
        CommonModule,
        ReactiveFormsModule
    ],
    imports: [
        CommonModule,
        OverlayModule,
        PortalModule,
        ReactiveFormsModule
    ],
    providers: [
        ModalDialogService,
        NotificationPaneService
    ]
})
export class SharedLibraryModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedLibraryModule
        };
    }
}
